
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { commentsReducer } from './reducer';
import { CommentsStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, commentsReducer),
		EffectsModule.forFeature([CommentsStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class CommentsStoreModule { }
